module.exports = __webpack_public_path__ + "static/media/minus-square-black.c4057ea7.svg";